import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './Home';
import NotFound from './NotFound';
import About from './About';
import Resume from './Resume';
import Nav from './Nav.js';


function Base() {
    return (
        <Router>
            <Nav />
            <Routes>
                <Route path='/' element={<Home />}/>
                <Route path='/home' element={<Home />}/>
                <Route path='/about' element={<About />}/>
                <Route path='/resume' element={<Resume />}/>
                <Route path='*' element={<NotFound />}/>
            </Routes>
        </Router>
    );
};

export default Base;